import React, { useEffect } from 'react'
import { find, first } from 'libraries/lodash'
import url from 'front-end-core/core/url'
import { LEGISLATION } from 'constants/controllers'
import { replaceUrl } from 'front-end-core/core/history'
import { AdminButton, ContentEditor, TitleEditor } from 'components/legislation/admin'
import Title from 'components/legislation/Title'
import { expandCallback, selectCallback } from 'services/LegislationService'
import Copyright from 'pages/legislation/Copyright'
import SectionHeaderOverride from 'components/legislation/SectionHeader'
import AdminBarContainer from 'redux/containers/components/legislation/admin/AdminBarContainer'
import AccordionWrapperContainer from 'redux/containers/components/accordion/AccordionWrapperContainer'

const Wrapper = ({
  actSections,
  setLegislationActNodes,
  act,
  editingId,
  editMode,
  group,
  admin,
  publishedId,
  versions,
  setEditMode,
  setAdminButton,
  setContentEditor,
  setTitleEditor,
  publisher,
  flavour,
  actIdMap,
  highlight
}) => {
  useEffect(() => {
    actSections && actSections.nodes && setLegislationActNodes(actSections.nodes)
    return () => setLegislationActNodes(false)
  }, [actSections])

  useEffect(() => {
    const { isArchived } = first(group)
    if (isArchived && flavour !== 'archive') {
      const pageId = url(LEGISLATION, { path: act, editingId, flavour: 'archive' })
      replaceUrl(pageId)
    } else if (!isArchived && flavour === 'archive') {
      const pageId = url(LEGISLATION, { path: act, editingId, flavour: 'full' })
      replaceUrl(pageId)
    }
  }, [])

  useEffect(() => {
    setAdminButton(AdminButton)
  }, [setAdminButton])

  useEffect(() => {
    setContentEditor(ContentEditor)
  }, [setContentEditor])

  useEffect(() => {
    setTitleEditor(TitleEditor)
  }, [setTitleEditor])

  useEffect(() => {
    const version = find(
      versions,
      v => Number(v.versionId) === Number(editingId)
    )
    const original = version ? version.original : false
    const published = version && Number(version.versionId) === Number(publishedId)
    setEditMode(admin && !!editingId && !original && !published)
  }, [setEditMode, versions, admin, editingId, publishedId])

  const editPage = admin && !!editingId
  const mainUrl = url(LEGISLATION, { flavour, path: act })
  const editUrl = url(LEGISLATION, { flavour, path: act, editingId: publishedId })

  // Not updating for now as we don't appear to support this behaviour. Not deleting in case I'm wrong.
  const adminButton = admin ? <AdminButton url={editPage ? mainUrl : editUrl} {...{ editMode }} /> : null
  const adminBar = editPage ? <AdminBarContainer {...{ publishedId, editingId, act, publisher }} /> : null
  const title = actIdMap && actIdMap.has(act) ? actIdMap.get(act).category : null

  const accordionProps = {
    title: <Title {...{ adminButton, title }} />,
    cxNames: {
      accordionContainer: 'bg-white pb8 mb6',
      groupHeader: {
        depthStyle: (depth) => {
          switch (depth) {
            case 2:
              return 'bg-medium-purple white b--medium-purple ie-min-height-flex-items-center-fix'
            default:
              return 'bg-ghost-grey b--medium-purple'
          }
        },
        iconDepthStyle: depth => {
          switch (depth) {
            case 2:
              return 'white'
            default:
              return 'black o-80'
          }
        }
      },
      contentHeader: {
        borderColor: 'b--medium-purple'
      },
      content: {
        divider: 'bt--medium-purple'
      },
      borderColor: 'b--dark-orchid'
    },
    group,
    eventCategory: 'Legislation',
    selectCallback,
    expandCallback,
    copyright: <Copyright />,
    adminBar,
    editMode,
    SectionHeaderOverride,
    styleTitle: false,
    highlight
  }

  return <AccordionWrapperContainer {...accordionProps} />
}

export default Wrapper
